import { render, staticRenderFns } from "./LineNumbers.vue?vue&type=template&id=31353e21&"
import script from "./LineNumbers.vue?vue&type=script&lang=ts&"
export * from "./LineNumbers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports